@if (viewModel().length > 0) {
  @for (residential of viewModel(); track residential.originalObject.cacheId) {
    <button
      (click)="selectObject(residential.originalObject)"
      (keydown.enter)="selectObject(residential.originalObject)"
      tabindex="0"
      data-testid="object-row"
      class="flex items-center !text-p1b bg-primary-accumin-black-05 text-primary-accumin-purple-100 rounded-lg mb-1 p-3 cursor-pointer transition-colors duration-200 hover:bg-accumin-sky-100 hover:text-primary-accumin-purple-100 w-full text-left focus:outline-none focus:ring-2 focus:ring-primary-accumin-purple-100"
    >
      <div class="flex justify-between w-full">
        <div class="flex items-center">
          @if (residential.typeTranslationKey) {
            <span>{{ residential.typeTranslationKey | transloco }}</span>
          }
          @if (residential.typeTranslationKey && residential.livingSpace) {
            <div class="text-primary-accumin-black-25 mx-2" data-testid="living-space">|</div>
          }
          @if (residential.livingSpace) {
            <span>{{ residential.livingSpace | translocoDecimal: { minimumFractionDigits: 0, maximumFractionDigits: 0 } }} m²</span>
          }
          @if (residential.livingSpace && residential.floor) {
            <div class="text-primary-accumin-black-25 mx-2" data-testid="floor">|</div>
          }
          @if (residential.floor) {
            <span
              >{{ "Module.ObjectInformation.Floor" | transloco }}
              {{ residential.floor | translocoDecimal: { minimumFractionDigits: 0, maximumFractionDigits: 0 } }}</span
            >
          }
          @if (residential.floor && residential.unit) {
            <div class="text-primary-accumin-black-25 mx-2" data-testid="unit">|</div>
          }
          @if (residential.unit) {
            <span>{{ "General.Unit" | transloco }} {{ residential.unit }}</span>
          }
        </div>

        @if (residential.customerId) {
          <div class="flex items-center gap-2 ml-4">
            <span class="text-primary-accumin-black-75 text-p1b">{{ residential.customerId }}</span>
          </div>
        }
        @if (residential.isCache) {
          <div class="flex items-center gap-2 ml-4">
            <span class="text-primary-accumin-black-25 text-p1b">{{ residential.creationDateTime | formatDate }}</span>
            <mat-icon
              data-testid="cache-icon"
              svgIcon="icn-restore"
              class="inline !w-5 !h-5 mr-2 text-primary-accumin-purple-100"
              [matTooltip]="'Module.Cache.RequestFromCache' | transloco"
            />
          </div>
        }
      </div>
    </button>
  }
} @else {
  <div class="bg-primary-accumin-black-05 text-primary-accumin-black-50 font-medium rounded-lg mb-1 p-3 w-full text-left">
    <span>{{ "General.NoData" | transloco }}</span>
  </div>
}

@if (createEnabled()) {
  <button
    (click)="createNewObjectClicked.emit()"
    (keydown.enter)="createNewObjectClicked.emit()"
    (keydown.space)="createNewObjectClicked.emit()"
    tabindex="0"
    class="flex items-center !text-p1b bg-primary-accumin-black-05 text-primary-accumin-purple-100 rounded-lg mb-1 p-3 cursor-pointer transition-colors duration-200 hover:bg-accumin-sky-100 hover:text-primary-accumin-purple-100 w-full text-left focus:outline-none focus:ring-2 focus:ring-primary-accumin-purple-100"
    data-testid="add-new-address"
  >
    <mat-icon svgIcon="icn-add" class="!w-5 !h-5 mr-2 text-primary-accumin-purple-100" />
    <span>{{ createNewTitleTranslationKey() | transloco }}</span>
  </button>
}
